import Vue from 'vue';
import {Component} from 'vue-property-decorator';
import axios from 'axios';
import {DateTimeHelper} from '../../utils/DateTimeHelper.util';
import {IRight, RightDto} from "../../models/right";

@Component({
  components: {
    'settings-child-notification': async () => import('./settings-child-notification/SettingsChildNotification.vue')
  }
})
class SettingsAdminContainer extends Vue {

  search: string;
  roles: any[];
  allRights: any[];
  selectedRoleId: number;
  headersRoleRights: any[];
  headersAllRights: any[];
  currentRoleRights: any[];
  currentRightsList: any[];
  editOrCreateRightDialog: boolean;
  confirmRightDialog: boolean;
  confirmRoleDialog: boolean;
  createRoleDialog: boolean;
  attachOrRemoveRightToRoleDialog: boolean;
  selectedRightPrevious: IRight;
  selectedRight: IRight;
  secureRightName: string;
  loading: boolean;
  typeModalRight: string;
  typeModalRole: string;
  roleToAdd: { name: string, role: string }

  constructor() {
    super();
    this.search = ''
    this.roles = []
    this.allRights = []
    this.selectedRoleId = -1
    this.currentRoleRights = []
    this.currentRightsList = []
    this.headersRoleRights = [
      {text: 'Nom', value: 'name'},
      {text: 'Description', value: 'description'},
      {text: 'Route', value: 'route'},
      {text: 'Accès', value: 'access'},
      {text: 'Methode', value: 'method'},
      {text: 'Droit ajouté', value: 'createdAt'},
      {text: 'Actions', value: 'name', sortable: false}
    ]
    this.headersAllRights = [
      {text: 'Nom', value: 'name'},
      {text: 'Description', value: 'description'},
      {text: 'Route', value: 'route'},
      {text: 'Accès', value: 'access'},
      {text: 'Methode', value: 'method'},
      {text: 'Droit créé', value: 'createdAt'},
      {text: 'Actions', value: 'name', sortable: false}
    ]
    this.editOrCreateRightDialog = false
    this.confirmRightDialog = false
    this.confirmRoleDialog = false
    this.attachOrRemoveRightToRoleDialog = false
    this.createRoleDialog = false
    this.selectedRightPrevious = new RightDto()
    this.selectedRight = new RightDto()
    this.secureRightName = ''
    this.loading = false
    this.typeModalRight = ''
    this.typeModalRole = ''
    this.roleToAdd = {name: '', role: ''}
  }

  get lblSetting() {
    return {...require('../../locales/settings-admin').default}
  }

  get methodValues() {
    return RightDto.methodValues
  }

  get accessValues() {
    return RightDto.accessValues
  }

  get roleNameSelected() {
    if (this.selectedRoleId == -1) return ''
    return this.roles.find(role => role.id === this.selectedRoleId).name
  }

  get roleRoleSelected() {
    if (this.selectedRoleId == -1) return ''
    return this.roles.find(role => role.id === this.selectedRoleId).role
  }

  get titleModalRight() {
    switch (this.typeModalRight) {
      case 'create':
        return 'Créer droit'
      case 'edit':
        return 'Editer droit'
      case 'add':
        return 'Attacher un droit à un role'
      case 'remove':
        return 'Détacher un droit à un role'
      case 'delete':
        return 'Supprimer un droit'
      default:
        return ''
    }
  }

  get subTitleConfirmModalRight() {
    switch (this.typeModalRight) {
      case 'create':
        return 'Vous allez créer le droits suivant :'
      case 'edit':
        return 'Vous allez modifier le droits suivant :'
      case 'add':
        return 'Vous êtes sur le point d\'attacher le droit'
      case 'remove':
        return 'Vous êtes sur le point de détacher le droit'
      case 'delete':
        return 'Vous êtes sur le point de supprimer totalement le droit (action irréversible) :'
      default:
        return ''
    }
  }

  get subTitleConfirmModalRole() {
    switch (this.typeModalRole) {
      case 'create':
        return 'Vous êtes sur le point de créer le role suivant :'
      case 'delete':
        return 'Vous êtes sur le point de supprimer le role suivant :'
      default:
        return ''
    }
  }

  get isValidRole() {
    return (this.roleToAdd.name && this.roleToAdd.role)
  }

  get roleAsRight() {
    return this.roles.find(role => role.id === this.selectedRoleId).rights.length > 0
  }

  parseDateTime(date) {
    return DateTimeHelper.parseDateTime(date)
  }

  openEditRight(selectedRight) {
    this.typeModalRight = 'edit'
    this.selectedRightPrevious = new RightDto(selectedRight)
    this.selectedRight = new RightDto(selectedRight)
    this.editOrCreateRightDialog = true
  }

  openAttachRight(selectedRight) {
    this.typeModalRight = 'add'
    this.selectedRight = new RightDto(selectedRight)
    this.attachOrRemoveRightToRoleDialog = true
  }

  openRemovePermission(selectedRight) {
    this.typeModalRight = 'remove'
    this.selectedRight = new RightDto(selectedRight)
    this.attachOrRemoveRightToRoleDialog = true
  }

  openDeleteRight(selectedRight) {
    this.typeModalRight = 'delete'
    this.selectedRight = new RightDto(selectedRight)
    this.confirmRightDialog = true
  }

  openCreateRight() {
    this.typeModalRight = 'create'
    this.selectedRight = new RightDto()
    this.selectedRightPrevious = new RightDto()
    this.editOrCreateRightDialog = true
  }

  openCreateRole() {
    this.typeModalRole = 'create'
    this.roleToAdd = {name: '', role: ''}
    this.createRoleDialog = true
  }

  openDeleteRole() {
    this.typeModalRole = 'delete'
    this.roleToAdd = {name: this.roleNameSelected, role: this.roleRoleSelected}
    this.confirmRoleDialog = true
  }


  async confirmActionRight() {
    this.loading = true
    if (this.typeModalRight === 'create') {
      console.log('Right TO create == ', this.selectedRight)
      let response = await axios.post('/right', this.selectedRight)
      console.log('response post right ===== ', response)
    } else if (this.typeModalRight === 'edit') {
      let response = await axios.patch('/right/' + this.selectedRight.id, this.selectedRight)
      console.log('response patch right ===== ', response)
    } else if (this.typeModalRight === 'delete') {
      let response = await axios.delete('/right/' + this.selectedRight.id)
      console.log('response delete right ===== ', response)
    }
    await this.loadDatas()
    this.confirmRightDialog = false
    this.editOrCreateRightDialog = false
    this.loading = false
    this.secureRightName = ''
    this.selectedRight = new RightDto()
    this.selectedRightPrevious = new RightDto()
  }

  async createOrDeleteRole() {
    this.loading = true
    if (this.typeModalRole === 'create') {
      console.log('Role to create == ', this.roleToAdd)
      let response = await axios.post('/role', this.roleToAdd)
      console.log('response post role ===== ', response)
    } else if (this.typeModalRole === 'delete' && this.selectedRoleId !== -1) {
      console.log('Role to delete == ', this.roleNameSelected)
      let response = await axios.delete('/role/' + this.selectedRoleId)
      console.log('response delete role ===== ', response)
    } else console.error('Impossible to delete this role !')
    this.selectedRoleId = -1
    await this.loadDatas()
    this.confirmRoleDialog = false
    this.createRoleDialog = false
    this.loading = false
    this.roleToAdd = {name: '', role: ''}
  }

  async patchRole(params) {
    this.loading = true
    console.log(params)
    await axios.patch('/role/' + this.selectedRoleId, params)
    await this.loadDatas()
    this.loading = false
  }

  async addOrRemoveRightToRole() {
    let params = null;
    if (this.typeModalRight === 'add')
      params = {rightsToAdd: [this.selectedRight.id],}
    else if (this.typeModalRight === 'remove')
      params = {permissionsToDelete: [this.selectedRight.permission.id]}
    if (params !== null) await this.patchRole(params)
    else console.error('No params for update role !!!')
    this.attachOrRemoveRightToRoleDialog = false
  }

  async getAllRole() {
    let response = await axios.get('/role')
    //console.log('role response', response);
    this.roles = await response.data.data.data
  }

  async getAllRight() {
    try {
      let response = await axios.get('/right')
      //console.log('right ===', response);
      this.allRights = await response.data.data
      this.currentRightsList = await this.allRights
    } catch (error) {
      console.error(error);
    }
  }

  async sortRights() {
    if (this.selectedRoleId !== -1) {
      this.currentRoleRights = await this.roles.find(role => {
        return role.id === this.selectedRoleId
      }).rights
      // Display only right not in the current role selected
      this.currentRightsList = await this.allRights.filter(right => {
        return this.currentRoleRights.findIndex(roleRight => right.id === roleRight.id) === -1
      })
    }
  }

  async loadDatas() {
    await this.getAllRight()
    await this.getAllRole()
    await this.sortRights()

    /*console.log('L\'agenda est dans le role ? => ', await this.currentRoleRights.find(right => {
      return right.id === this.selectedRight.id
    }))
    console.log('L\'agenda est dans la liste de droit ? => ', await this.currentRightsList.find(right => {
      return right.id === this.selectedRight.id
    }))*/
  }

  mounted() {
    this.loadDatas().then(() => {
      this.$watch('selectedRoleId', async () => {
        await this.sortRights()
      })
    })
  }
}

export default SettingsAdminContainer;



// WEBPACK FOOTER //
// ./src/containers/settings/index.ts